var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('span',_vm._g({staticClass:"grey--text date-tooltip"},on),[_vm._v(_vm._s(_setup.fromNowDate))])]}}])},[_c('span',[_vm._v(_vm._s(_setup.formattedDate))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }